/* eslint-disable no-undef */
/* eslint-disable func-names */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * Sticky Header
 * @param   {object/string} opts
 * @return  {object/string}
 */
 export default ((am2, $) => {
	return function () {


		const { ajaxUrl } = am2;
		const loader = $('.js-loader');
		const container = $('.js-posts-list');
		const loadMore = $('.js-load-more');
		const postsPerPage = container.find('.js-post-item').length;
		var listCategory = container.data('category');
		// let category = 

		$('.cat-list_item').on('click', function() {
			console.log(listCategory);
			listCategory = $(this).data('slug');
			container.attr('category', $(this).data('slug'));
			console.log(listCategory);
			
			$('.cat-list_item').removeClass('active');
			$(this).addClass('active');
			
			$(".js-load-more").show();
        
			$.ajax({
				type: 'POST',
				// url: 'http://dev.geologija.hr/wp-admin/admin-ajax.php',
				url: ajaxUrl,
				dataType: 'html',
				data: {
					action: 'filter_projects',
					postsPerPage: postsPerPage,
					category: $(this).data('slug'),
					loadMore: true,
					postOffset: 0
				},
				success: function(res) {
					$('.archive-news__list').html(res);
				},
			});

		});

		const loadAjaxPosts = (categorySlug = '') => {
			const postNumber = container.find('.js-post-item').length;

			$.ajax({
				type: 'POST',
				url: ajaxUrl,
				data: {
					action: "filter_projects",
					postsPerPage: postsPerPage,
					category: categorySlug,
					loadMore: true,
					postOffset: postNumber,

				},
				beforeSend: function () {
					loader.addClass('loading');
				},
				success: function (res) {
					// let data = $.parseJSON(response);
					// console.log(res);
					// if (!res.show_load_more) {
					// 	$(".js-load-more").hide();
					// } else {
					// 	$(".js-load-more").show();
					// }

					$('.archive-news__list').append(res);

					loader.removeClass("loading");
				}
			});
		};

		$(document).ready(function () {
			if ( postsPerPage < 6 ) {
				// $(".js-load-more").hide();
			}
			loadMore.on('click', function () {

				loadAjaxPosts(listCategory);
			});


			
		});

	};
}).apply(this, [window.am2, jQuery]);

